export const menu = () => {
  if (document.querySelector('.header--hamburger')) {
    const hamburger = document.querySelector('.header--hamburger');
    const nav = document.querySelector('.header--nav');
    const wrapper = document.createElement('div');
    for (let i = 0; i < 3; i++) {
      const span = document.createElement('span');
      wrapper.appendChild(span);
    }
    hamburger.appendChild(wrapper);
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('__js_isActive');
      nav.classList.toggle('__js_isActive');
    });
    nav.addEventListener('click', (e) => {
      if (!e.target.closest('[data-slug]')) return;
      nav.classList.remove('__js_isActive');
      hamburger.classList.remove('__js_isActive');
    });
    document.querySelector('.header').addEventListener('mouseleave', () => {
      nav.classList.remove('__js_isActive');
      hamburger.classList.remove('__js_isActive');
    });
  }
};
